export default __webpack_public_path__ + "static/media/bg-sign_in.2a2a85d0.png";